export enum SearchableDropdownTheme {
  FORM_CONTROL = 'form-control-theme',
  TOOLBAR_DROPDOWN_LIGHT = 'toolbar-dropdown-light-theme',
}
